import { createSelector } from 'reselect';

// Types
import { RootState } from 'types/RootState.types';

// Config
import { isExpressPaypalV2 } from '@redux/actions/payment/payPalPaymentActions';
import { getSessionIdSelector } from '@redux/reducers/bff/bffSelector';
import {
  getGetPayPalClientTokenCallActiveSelector,
  getPayPalClientTokenSelector,
  getPayPalStubsModalOpenSelector,
} from '@redux/reducers/payment/paymentSelector';

const getExpressPaypalV2FeatureActiveSelector = (state: RootState) => isExpressPaypalV2(state);

const payPalButtonState = createSelector(
  [
    getGetPayPalClientTokenCallActiveSelector,
    getPayPalClientTokenSelector,
    getPayPalStubsModalOpenSelector,
    getSessionIdSelector,
    getExpressPaypalV2FeatureActiveSelector,
  ],
  (getPayPalClientTokenCallActive, payPalClientToken, payPalStubsModalOpen, sessionId, isExpressPaypalV2) => ({
    getPayPalClientTokenCallActive,
    payPalClientToken,
    payPalStubsModalOpen,
    sessionId,
    isExpressPaypalV2,
  }),
);

export default payPalButtonState;
